import { render, staticRenderFns } from "./TypeGameData.vue?vue&type=template&id=44861d9c&scoped=true&"
import script from "./TypeGameData.vue?vue&type=script&lang=js&"
export * from "./TypeGameData.vue?vue&type=script&lang=js&"
import style0 from "./TypeGameData.vue?vue&type=style&index=0&id=44861d9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44861d9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VIcon,VSelect,VTextField})
